module.exports = __webpack_public_path__ + "static/media/ic-direct-debit-blue.e3c60268.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-direct-debit-blue.svg
// module id = 619
// module chunks = 14